<template>
  <div class="main-content group-data-[sidebar-size=lg]:xl:ml-[calc(theme('spacing.app-menu')_+_16px)] group-data-[sidebar-size=sm]:xl:ml-[calc(theme('spacing.app-menu-sm')_+_16px)] px-4 group-data-[theme-width=box]:xl:px-0 ac-transition">
        <div class="card">
            <h2 class="card-title">Barcode List</h2>
            <button type="reset" @click="hideprintBarcode" class="btn b-light btn-info-light btn-sm">Products</button>
        </div>
    <button @click="printLabels" class="btn b-light btn-danger-light btn-sm">Print Barcodes</button>
    <div id="barcode-container" ref="barcodeContainer">
      <div v-for="n in productsList.length" :key="n" :class="isChecked(n-1)?'barcode-label':'hide'" >
        <svg :id="'barcode-' + n"></svg>
        <p class="sm-txt">{{ generateBarcodeDetails(n) }}</p> 
        <p class="sm-txt">{{ generateBarcodeRates(n) }}</p> 
      </div>
    </div>
  </div>
</template>
<style>
    .sm-txt{
        font-size: 12px;
    }
</style>

<script>
import JsBarcode from "jsbarcode"; 

export default {
     props: {
         GetproductsList:Array
     },
  data() {
    return {
        productsList:this.GetproductsList,
    };
  },
mounted(){
 this.generateBarcodes();
},
  methods: { 
      
      hideprintBarcode(){
        this.$emit('hideprintBarcode'); 
      },
    generateBarcodeRates(index) {
      // This function generates the text for each barcode
      var item=this.productsList[index-1];
      if(item)
          return   'Rate: '+item.salerate+' ST.Rate:'+item.stich_rate;
      else   
        return '';
    },
    isChecked(index){
        
        try {
            
            if(this.productsList[index].checked==1)
                return true;
            else
                return false;
                
        } catch (e) {
                return false;
            
        }
    },
    generateBarcodeDetails(index) {
      // This function generates the text for each barcode
      var item=this.productsList[index-1];
      if(item)
          return   item.name.toString();
      else   
        return '';
    },
    generateBarcodeText(item) {
      // This function generates the text for each barcode
      if(item)
          return   item.barcode.toString().padStart(5, "0");
      else   
        return '';
    },
    
    generateBarcodes() {
      // Generate 100 barcodes
      for (let i = 0; i < this.productsList.length; i++) {
        
          if(this.isChecked(i)){
                const barcodeText = this.generateBarcodeText(this.productsList[i]);
                JsBarcode(`#barcode-${i+1}`, barcodeText, {
                  format: "CODE128",
                  lineColor: "#000",
                  width: 2,
                  height: 40,
                  displayValue: true
                });
          }
      }
    },
    printLabels() {
      // Call this method when you want to print the labels
      this.generateBarcodes();
      setTimeout(() => {
        const printContent = this.$refs.barcodeContainer.innerHTML;
        const originalContent = document.body.innerHTML;
        document.body.innerHTML = printContent;
        window.print();
        document.body.innerHTML = originalContent;
        window.location.reload();
      }, 1000); // Wait for barcodes to render before printing
    }
  }, 
};
</script>

<style>
#barcode-container {
  display: flex;
  flex-wrap: wrap;
}
.hide{
    display: none;
}
.barcode-label {
  width: 200px;
  margin: 10px;
  text-align: center;    
  border: 1px solid;
  text-align: -webkit-center;
  background: white;
}
</style>
